import ClientConfiguration from "./client_config.json";
window.TVSite = window.TVSite || {};

class ClientConfigurationHelper {
    constructor() {
        this.configuration = ClientConfiguration.client_config;// TVSite.client_config;
        this.setUrls();
        this.setClientHash();
        this.setPhpEnv();
        TVSite.apiUrl = ClientConfiguration.apiUrl;
        TVSite.newApiBaseUrl = ClientConfiguration.newApiBaseUrl;
        TVSite.apiBaseUrlV3 = ClientConfiguration.apiBaseUrlV3;
    }
    enableHeaderFooter(){
        if(TVSite && TVSite.hasOwnProperty("enableHeaderFooter"))
            return TVSite.enableHeaderFooter;
        else
            return true;
    }
    hasStrLen = (srt) => {if(srt) return (srt.length && srt.length > 0) || /[a-z0-9]/i.test(srt)}
    setUrls =()=>{
            const {public_base_url, sub_folder} = this.configuration?.experiences?.publishing;
            TVSite.public_base_url = this.hasStrLen(public_base_url) ? public_base_url : '';
            TVSite.sub_folder = this.hasStrLen(sub_folder) ? "/"+sub_folder.split('/').filter(f=>!!f).join('/') : '';
    }
    setClientHash =()=>{
        if(this.configuration && this.configuration.client && this.configuration.client.hash)
            TVSite.clientHash = this.configuration.client.hash;
        else
            TVSite.clientHash = "Missing client hash"
    }
    setPhpEnv =()=>{
        if(ClientConfiguration && ClientConfiguration.php_env_name)
            TVSite.phpEnvName = ClientConfiguration.php_env_name;
        else
            TVSite.phpEnvName = "Missing phpEnvName"
    }
    getCurrencySymbol=()=>{
        if(this.configuration && this.configuration.experiences && this.configuration.experiences.currency_symbol) {
            return this.configuration.experiences.currency_symbol;
        }else
            return '$'
    }
    getPlayerSharing=()=>{
        if(this.configuration && this.configuration.experiences && this.configuration.experiences.hub &&
            !!this.configuration.experiences.hub.sharing) {
            const sharing = this.configuration.experiences.hub.sharing;
            if(!sharing.domain)
                sharing.domain = sharing.base_url;
            return sharing;
        }else
            return null
    }
    getLatestVideosChannelId = () => {
        if (this.configuration && this.configuration.experiences && this.configuration.experiences.hub &&
            this.configuration.experiences.hub.channels && this.configuration.experiences.hub.channels.latest &&
            this.configuration.experiences.hub.channels.latest > 0)
            return this.configuration.experiences.hub.channels.latest;
        else
            console.log("Missing latest channel id in client config");
    }
    getRelatedVideosChannelId = () => {
        if (this.configuration && this.configuration.experiences && this.configuration.experiences.hub &&
            this.configuration.experiences.hub.channels && this.configuration.experiences.hub.channels.related &&
            this.configuration.experiences.hub.channels.related > 0)
            return this.configuration.experiences.hub.channels.related;
        else
            console.log("Missing latest channel id in client config");
    }
    useRecommendedProducts(){
        if (this.configuration && this.configuration.experiences && this.configuration.experiences.hub && this.configuration.experiences.hub.recommendedProducts)
            return this.configuration.experiences.hub.recommendedProducts;
        else
            return true;
    }
    isAmbassadorProgramEnabled(){
        if(this.configuration && this.configuration.client)
            return this.configuration.client.ambassador_program_enabled;
        else
            return false;
    }
    productThumbnailPresentation(){
        if (this.configuration && this.configuration.experiences && this.configuration.experiences.hub && this.configuration.experiences.hub.keepProductsAspectRatio)
            return "keep-aspect-ratio";
        else
            return "cover-mode";
    }
    getExperienceTitle(){
        if (this.configuration && this.configuration.experiences && this.configuration.experiences.hub && this.configuration.experiences.hub.title)
            return this.configuration.experiences.hub.title;
        else
            return "(Experience name)";
    }
    getDefaultLogo(){
        if(this.configuration && this.configuration.client.brand.logo && this.configuration.client.brand.logo)
            return this.configuration.client.brand.logo.default;
        else
            return "";
    }
    getClientSiteLinks () {
        if (this.configuration && this.configuration.client && this.configuration.client.links)
            return this.configuration.client.links;
        else
            return {};
    }
    getGlobalConfiguration = () => {
        if (window.hasOwnProperty("TVSite"))
            return window.TVSite;
        else
            throw new Error("global instance TVSite not available");
    }
    useAffiliateProductsLink = () =>{
        if(this.configuration && this.configuration.experiences && this.configuration.experiences.hasOwnProperty('enable_affiliate_short_link'))
            return this.configuration.experiences.enable_affiliate_short_link;
        else
            return false;
    }

    getSignInSettings = () => {
        if(this.configuration && this.configuration.experiences && this.configuration.experiences.hasOwnProperty('hub') && this.configuration.experiences.hub.hasOwnProperty('sign_in'))
            return this.configuration.experiences.hub.sign_in;
        else
            return false;
    }

    getDashboardSection = () => {
        if(this.configuration && this.configuration.dashboards)
            return this.configuration.dashboards;
        else
            return false;
    }
    getProductsCTAText = () =>{
        if(this.configuration && this.configuration.experiences && this.configuration.experiences.hasOwnProperty('hub') && this.configuration.experiences.hub.hasOwnProperty('product_cta_text'))
            return this.configuration.experiences.hub.product_cta_text;
        else
            return "BUY NOW";
    }
    getProductsCTAModalText = () =>{
        if(this.configuration && this.configuration.experiences && this.configuration.experiences.hasOwnProperty('hub') && this.configuration.experiences.hub.hasOwnProperty('product_cta_modal_text'))
            return this.configuration.experiences.hub.product_cta_modal_text;
        else
            return "BUY NOW";
    }
    getContentSearchVersion = () => {
        const { experiences } = this.configuration;
        if (experiences?.content_search_version)
            return experiences.content_search_versioon;
        else return "v3";
    }
    getSearchKey = () => {
        //return "08ahX18YCglqK8oZlNVsGAyv1v9Wqo1j"
        const { experiences } = this.configuration;
        if (experiences?.content_search_key)
            return experiences.content_search_key;
        else throw new Error("Missing content search key");
    }
    getContentSearchUrl = () => {
        const phpEnvName = window?.TVSite?.phpEnvName;
        const env = phpEnvName === "local" ? "stage" : phpEnvName;
        const part = env === "app" ? "" : "." + env;
        const version = this.getContentSearchVersion();
        return `https://content${part}.creatable.io/graphql/${version}/${this.getSearchKey()}`;
    }
    getContentApiRequestBody = (page, creator_id) =>{
        let filter = '';
        if (creator_id) {
            filter = `, filter: {AND: [{creator_id: ${creator_id}}]}`;
        }
        return `{
            content(page: ${page}, per_page: 12 ${filter}) {
                total
                items {
                    content_id
                    title
                    page_url
                    uri_stem
                    description
                    creator {
                        creator_id
                        employee_id
                        uri_stem
                        thumbnail
                        first_name
                        full_name
                        last_name
                        region {
                            name
                        }
                        store {
                            name
                            store_number
                        }
                    }
                    products {
                        product_id
                        image
                        price
                        sale_price
                        title
                        link
                    }
                    attributes {
                        code
                        value
                    }
                    content_type
                    creation_date
                    asset {
                        asset_type
                        video {
                            thumbnails {
                                width
                                height
                                url
                            }
                        }
                        photo {
                            thumbnails {
                                url
                                width
                                height
                            }
                        }
                    }
                }
            }
        }`;

    }

}

export default new ClientConfigurationHelper();